import { render, staticRenderFns } from "./RecentKBView.vue?vue&type=template&id=e97389da&scoped=true"
import script from "./RecentKBView.vue?vue&type=script&lang=js"
export * from "./RecentKBView.vue?vue&type=script&lang=js"
import style0 from "./RecentKBView.vue?vue&type=style&index=0&id=e97389da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e97389da",
  null
  
)

export default component.exports